export interface Drama {
  id: string;
  title: string;
  coverImage: string;
  bannerImage: string;
  description: string;
  longDescription: string;
  category: string;
  categories: string[];
  rating: number;
  year: number;
  episodes: number;
  status: '更新中' | '已完结';
  actors: string[];
  director: string;
  region: string;
  language: string;
  updateInfo: string;
  featured: boolean;
  views: number;
}

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'guzhuang', name: '古装', icon: 'ri-vip-crown-line' },
  { slug: 'xiandai', name: '现代', icon: 'ri-building-line' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'aiqing', name: '爱情', icon: 'ri-heart-line' },
  { slug: 'xiju', name: '喜剧', icon: 'ri-emotion-laugh-line' },
  { slug: 'wuxia', name: '武侠', icon: 'ri-sword-line' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-2-line' },
];

export const dramas: Drama[] = [
  {
    id: 'drama-1',
    title: '长安十二时辰',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20with%20Tang%20dynasty%20aesthetic%2C%20mysterious%20warrior%20in%20traditional%20armor%20standing%20in%20ancient%20city%20at%20night%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20moody%20atmosphere%20with%20warm%20lantern%20glow%2C%20professional%20drama%20poster%20design%20with%20Chinese%20calligraphy%20style&width=600&height=800&seq=drama-cover-1&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20cityscape%20at%20night%20during%20Tang%20dynasty%2C%20bustling%20market%20streets%20with%20red%20lanterns%2C%20dramatic%20cinematic%20lighting%2C%20warm%20amber%20tones%2C%20atmospheric%20mist%2C%20grand%20palace%20architecture%20in%20background%2C%20movie%20quality%20cinematography&width=1600&height=700&seq=drama-banner-1&orientation=landscape',
    description: '唐朝天宝三年，上元节前夕，长安城陷入一场惊天危机。死囚张小敬临危受命，与靖安司司丞李必携手在十二时辰内拯救长安。',
    longDescription: '本剧改编自马伯庸同名小说，讲述了唐朝天宝三年上元节前夕，长安城混入可疑人员，身陷囹圄的张小敬临危受命，与少年天才李必携手在十二时辰内破除隐患、拯救长安的故事。全剧以精密的剧情结构、考究的历史细节和电影级的制作水准，为观众呈现了一场视觉与智力的双重盛宴。剧中不仅有扣人心弦的悬疑推理，更有对人性、忠诚与牺牲的深刻探讨。',
    category: 'guzhuang',
    categories: ['guzhuang', 'xuanyi'],
    rating: 8.2,
    year: 2019,
    episodes: 48,
    status: '已完结',
    actors: ['雷佳音', '易烊千玺', '周一围', '芦芳生'],
    director: '曹盾',
    region: '中国大陆',
    language: '汉语普通话',
    updateInfo: '全48集',
    featured: true,
    views: 15800000,
  },
  {
    id: 'drama-2',
    title: '狂飙',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20crime%20drama%20poster%2C%20two%20men%20in%20suits%20facing%20each%20other%20with%20tense%20atmosphere%2C%20dark%20urban%20background%20with%20city%20lights%2C%20dramatic%20lighting%2C%20professional%20poster%20design%20with%20bold%20typography&width=600&height=800&seq=drama-cover-2&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20city%20nightscape%20with%20skyscrapers%2C%20dramatic%20noir%20lighting%2C%20rain%20on%20streets%2C%20moody%20atmosphere%2C%20crime%20thriller%20aesthetic%2C%20cinematic%20composition%2C%20deep%20blues%20and%20warm%20street%20lights&width=1600&height=700&seq=drama-banner-2&orientation=landscape',
    description: '以一线刑警安欣与黑恶势力高启强长达二十年的生死较量为主线，展现了一场跨越时代的正邪对决，深刻描绘了扫黑除恶的艰辛历程。',
    longDescription: '《狂飙》是一部反映扫黑除恶专项斗争的电视剧。该剧讲述了以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力展开的长达二十年生死较量的故事。通过群像叙事的方式，展现扫黑行动中的黑白较量与复杂人性。剧集以扎实的剧本、精湛的演技和深刻的主题，成为近年来最具影响力的国产剧之一，引发了全社会对扫黑除恶工作的广泛关注和讨论。',
    category: 'xiandai',
    categories: ['xiandai', 'xuanyi', 'dushi'],
    rating: 8.5,
    year: 2023,
    episodes: 39,
    status: '已完结',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    director: '徐纪周',
    region: '中国大陆',
    language: '汉语普通话',
    updateInfo: '全39集',
    featured: true,
    views: 25600000,
  },
  {
    id: 'drama-3',
    title: '庆余年',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20historical%20drama%20poster%2C%20young%20man%20in%20elegant%20ancient%20robe%20holding%20a%20sword%2C%20palace%20and%20mountains%20in%20background%2C%20golden%20warm%20lighting%2C%20epic%20fantasy%20aesthetic%2C%20professional%20poster%20design&width=600&height=800&seq=drama-cover-3&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20with%20grand%20architecture%20at%20sunset%2C%20golden%20warm%20light%2C%20misty%20mountains%2C%20fantasy%20historical%20setting%2C%20epic%20cinematic%20landscape%2C%20dramatic%20clouds&width=1600&height=700&seq=drama-banner-3&orientation=landscape',
    description: '一个身世神秘的少年范闲，自海边小城初出茅庐，历经家族、江湖、庙堂的种种考验与锤炼，书写了一段光彩夺目的人生传奇。',
    longDescription: '《庆余年》改编自猫腻同名小说，讲述了一个有着神秘身世的少年范闲，自海边小城初出茅庐，历经家族、江湖、庙堂的种种考验与锤炼的故事。他凭借过人的智谋与武艺，在复杂的权力斗争中步步为营，同时也在探寻着自己的身世之谜。全剧融汇了权谋、武侠、爱情等多种元素，以跌宕起伏的剧情和出色的演员阵容赢得了观众的广泛好评，被誉为近年来最成功的古装剧之一。',
    category: 'guzhuang',
    categories: ['guzhuang', 'wuxia'],
    rating: 7.9,
    year: 2019,
    episodes: 46,
    status: '已完结',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    director: '孙皓',
    region: '中国大陆',
    language: '汉语普通话',
    updateInfo: '全46集',
    featured: true,
    views: 31200000,
  },
  {
    id: 'drama-4',
    title: '三体',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%2C%20mysterious%20cosmic%20background%20with%20stars%20and%20planets%2C%20three%20suns%20in%20sky%2C%20futuristic%20yet%20grounded%20aesthetic%2C%20dark%20and%20atmospheric%2C%20professional%20poster%20design&width=600&height=800&seq=drama-cover-4&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Deep%20space%20with%20three%20suns%20and%20mysterious%20alien%20civilization%2C%20cosmic%20scale%2C%20dark%20vast%20universe%2C%20sci-fi%20cinematic%20landscape%2C%20stars%20and%20nebula%2C%20mysterious%20and%20awe-inspiring%20atmosphere&width=1600&height=700&seq=drama-banner-4&orientation=landscape',
    description: '纳米科学家汪淼被卷入一场神秘事件，随着调查深入，他逐渐发现了地外文明"三体"世界的存在，以及两个文明之间即将发生的碰撞。',
    longDescription: '《三体》改编自刘慈欣同名科幻小说，讲述了地球基础科学研究遭遇异常扰动，纳米科学家汪淼与刑警史强联手调查，揭开地外文明"三体"世界神秘面纱的故事。随着调查的深入，一场涉及两个文明命运的博弈徐徐展开。该剧以宏大的宇宙观和严谨的科学逻辑，将中国科幻影视推向了新的高度，在国际上也引发了广泛关注。精良的特效制作和深刻的哲学思考，使其成为国产科幻剧的里程碑之作。',
    category: 'kehuan',
    categories: ['kehuan', 'xuanyi'],
    rating: 8.0,
    year: 2023,
    episodes: 30,
    status: '已完结',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    director: '杨磊',
    region: '中国大陆',
    language: '汉语普通话',
    updateInfo: '全30集',
    featured: true,
    views: 18900000,
  },
  {
    id: 'drama-5',
    title: '隐秘的角落',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20thriller%20drama%20poster%2C%20three%20children%20standing%20in%20a%20dark%20alley%2C%20mysterious%20atmosphere%2C%20warm%20summer%20light%20contrasting%20with%20dark%20shadows%2C%20psychological%20thriller%20aesthetic&width=600&height=800&seq=drama-cover-5&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Small%20coastal%20Chinese%20town%20in%20summer%2C%20narrow%20alleyways%2C%20old%20buildings%2C%20warm%20sunlight%20casting%20long%20shadows%2C%20slightly%20eerie%20atmosphere%2C%20cinematic%20composition%2C%20contrast%20between%20bright%20and%20dark&width=1600&height=700&seq=drama-banner-5&orientation=landscape',
    description: '三个孩子在景区游玩时无意间拍摄记录了一场谋杀，由此卷入了一场无法预料的连锁反应中，讲述了一个关于善恶与人性的黑暗寓言。',
    longDescription: '《隐秘的角落》改编自紫金陈推理小说《坏小孩》，讲述了沿海小城的三个孩子在景区游玩时无意间拍摄记录了一场谋杀，由此他们的命运与一个杀人犯紧紧纠缠在一起的故事。该剧以精妙的叙事结构、深刻的主题表达和出色的表演，引发了全社会对家庭教育、青少年成长等话题的广泛讨论。秦昊饰演的张东升更是塑造了经典的荧幕反派形象，"一起去爬山"成为年度流行语。',
    category: 'xuanyi',
    categories: ['xuanyi', 'xiandai'],
    rating: 8.8,
    year: 2020,
    episodes: 12,
    status: '已完结',
    actors: ['秦昊', '王景春', '荣梓杉', '史彭元'],
    director: '辛爽',
    region: '中国大陆',
    language: '汉语普通话',
    updateInfo: '全12集',
    featured: false,
    views: 22100000,
  },
  {
    id: 'drama-6',
    title: '你是我的荣耀',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20drama%20poster%2C%20young%20couple%20looking%20at%20each%20other%20romantically%2C%20starry%20night%20sky%20background%2C%20soft%20warm%20lighting%2C%20modern%20romantic%20aesthetic%2C%20professional%20poster%20design&width=600&height=800&seq=drama-cover-6&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Romantic%20starry%20night%20sky%20over%20modern%20city%2C%20aerospace%20theme%2C%20satellite%20and%20stars%2C%20soft%20romantic%20atmosphere%2C%20purple%20and%20golden%20hues%2C%20dreamy%20cinematic%20landscape&width=1600&height=700&seq=drama-banner-6&orientation=landscape',
    description: '人气女星乔晶晶与高中时暗恋的学霸于途在游戏中重逢，一个是闪耀的明星，一个是航天设计师，两人在追梦路上互相扶持、彼此治愈。',
    longDescription: '《你是我的荣耀》改编自顾漫同名小说，讲述了人气女星乔晶晶在游戏中与曾经的高中同学于途意外重逢的故事。于途是一名心怀梦想的航天设计师，乔晶晶则是光彩夺目的大明星，两个看似不同世界的人，在追梦的道路上互相理解、彼此温暖。该剧以温暖的笔触描绘了当代年轻人的爱情与事业追求，航天元素的加入更让剧集增添了一份浪漫的理想主义色彩，播出后获得了极高的口碑和热度。',
    category: 'aiqing',
    categories: ['aiqing', 'xiandai', 'dushi'],
    rating: 7.6,
    year: 2021,
    episodes: 32,
    status: '已完结',
    actors: ['杨洋', '迪丽热巴', '潘粤明', '胡可'],
    director: '王之',
    region: '中国大陆',
    language: '汉语普通话',
    updateInfo: '全32集',
    featured: false,
    views: 34500000,
  },
  {
    id: 'drama-7',
    title: '琅琊榜',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%2C%20scholar%20in%20white%20robe%20standing%20in%20misty%20mountain%2C%20elegant%20and%20mysterious%2C%20traditional%20ink%20painting%20aesthetic%2C%20professional%20poster%20design&width=600&height=800&seq=drama-cover-7&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mountain%20landscape%20with%20mist%20and%20pine%20trees%2C%20traditional%20ink%20painting%20style%2C%20ethereal%20atmosphere%2C%20dramatic%20cliffs%20and%20waterfalls%2C%20mysterious%20and%20elegant%20composition&width=1600&height=700&seq=drama-banner-7&orientation=landscape',
    description: '十二年前，七万赤焰军被奸人所害全军覆没。十二年后，身中火寒毒的少年梅长苏重返帝都，以病弱之躯搅动朝堂风云，为赤焰军洗雪冤屈。',
    longDescription: '《琅琊榜》改编自海宴同名网络小说，讲述了"麒麟才子"梅长苏以病弱之躯拨开重重迷雾、智斗奸佞，为昭雪多年冤案、扶持新君所进行的一系列斗争。该剧以精良的制作、严密的剧情逻辑和深刻的人物塑造，被誉为中国古装剧的新标杆。剧中不仅有扣人心弦的权谋智斗，更有感人至深的家国情怀与兄弟情义，胡歌饰演的梅长苏更是成为了经典的荧幕形象。',
    category: 'guzhuang',
    categories: ['guzhuang', 'wuxia'],
    rating: 9.3,
    year: 2015,
    episodes: 54,
    status: '已完结',
    actors: ['胡歌', '刘涛', '王凯', '陈龙'],
    director: '孔笙',
    region: '中国大陆',
    language: '汉语普通话',
    updateInfo: '全54集',
    featured: true,
    views: 42000000,
  },
  {
    id: 'drama-8',
    title: '欢乐喜剧人',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20show%20poster%2C%20group%20of%20comedians%20laughing%20together%2C%20bright%20colorful%20stage%20lights%2C%20festive%20atmosphere%2C%20professional%20poster%20design%20with%20bold%20colors&width=600&height=800&seq=drama-cover-8&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20comedy%20stage%20with%20spotlights%2C%20theater%20curtains%2C%20festive%20entertainment%20atmosphere%2C%20warm%20vibrant%20colors%2C%20lively%20and%20joyful%20composition&width=1600&height=700&seq=drama-banner-8&orientation=landscape',
    description: '全国首档明星喜剧竞赛真人秀节目，汇聚国内顶尖喜剧人同台竞技，用欢笑传递温暖，为观众带来最纯粹的快乐。',
    longDescription: '《欢乐喜剧人》是一档汇聚了国内顶尖喜剧人才的竞技类综艺节目。节目邀请沈腾、贾玲、岳云鹏、宋小宝等知名喜剧演员参与，通过小品、相声、脱口秀等多种喜剧形式展开激烈角逐。每一期都充满了欢声笑语，同时也展现了喜剧人台前幕后的辛勤付出。节目不仅为观众带来了欢乐，更推动了中国喜剧文化的发展和创新。',
    category: 'xiju',
    categories: ['xiju', 'xiandai'],
    rating: 7.3,
    year: 2022,
    episodes: 24,
    status: '已完结',
    actors: ['沈腾', '贾玲', '岳云鹏', '宋小宝'],
    director: '施嘉宁',
    region: '中国大陆',
    language: '汉语普通话',
    updateInfo: '全24集',
    featured: false,
    views: 9800000,
  },
  {
    id: 'drama-9',
    title: '仙剑奇侠传',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20martial%20arts%20drama%20poster%2C%20young%20warriors%20with%20magical%20swords%20in%20ancient%20fantasy%20world%2C%20floating%20islands%20and%20cherry%20blossoms%2C%20epic%20romantic%20fantasy%20aesthetic&width=600&height=800&seq=drama-cover-9&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Fantasy%20ancient%20Chinese%20landscape%20with%20floating%20mountains%20and%20waterfalls%2C%20cherry%20blossom%20trees%2C%20magical%20atmosphere%2C%20ethereal%20lighting%2C%20epic%20fantasy%20cinematic%20composition&width=1600&height=700&seq=drama-banner-9&orientation=landscape',
    description: '李逍遥为求仙丹救婶婶，误打误撞结识了女娲后人赵灵儿，两人携手闯荡江湖，演绎了一段跨越三生三世的凄美爱情故事。',
    longDescription: '《仙剑奇侠传》改编自大宇资讯同名经典游戏，是中国仙侠剧的开山之作。讲述了渔村店小二李逍遥与女娲后人赵灵儿、林家堡大小姐林月如等人之间的爱恨情仇，以及他们联手对抗拜月教、拯救天下苍生的故事。该剧以唯美的画面、动人的配乐和青春洋溢的演员阵容，成为了一代人的经典回忆，胡歌和刘亦菲的搭档更是被观众誉为"神仙选角"。',
    category: 'wuxia',
    categories: ['wuxia', 'guzhuang', 'aiqing'],
    rating: 8.6,
    year: 2005,
    episodes: 34,
    status: '已完结',
    actors: ['胡歌', '刘亦菲', '安以轩', '彭于晏'],
    director: '于建福',
    region: '中国大陆',
    language: '汉语普通话',
    updateInfo: '全34集',
    featured: false,
    views: 38000000,
  },
  {
    id: 'drama-10',
    title: '三十而已',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20urban%20drama%20poster%2C%20three%20modern%20women%20in%20their%20thirties%20looking%20confident%2C%20city%20skyline%20background%2C%20elegant%20and%20sophisticated%20aesthetic%2C%20professional%20poster&width=600&height=800&seq=drama-cover-10&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Modern%20Shanghai%20cityscape%20at%20sunset%2C%20elegant%20high-rise%20buildings%2C%20warm%20golden%20light%2C%20sophisticated%20urban%20lifestyle%20aesthetic%2C%20cinematic%20composition&width=1600&height=700&seq=drama-banner-10&orientation=landscape',
    description: '三位三十岁都市女性，在生活、事业和感情中各自面临困境与选择，她们在挣扎中成长，在迷茫中寻找自我，展现了当代女性的独立与坚韧。',
    longDescription: '《三十而已》以三位三十岁女性视角展开，讲述了都市女性在三十岁这一重要年龄节点时，所遭遇的多重压力和人生态度的故事。顾佳是令人艳羡的金字塔上层，她把老公从烟花编程师打造成了"许总"，却面临婚姻危机；王漫妮是特立独行的叛逆者，深信自己有能力在都市站稳脚跟；钟晓芹是标准化的大多数，嫁给铁饭碗老公，却因写作爱好让婚姻产生裂痕。该剧真实地反映了当代都市女性的生存状态，引发了强烈的社会共鸣。',
    category: 'dushi',
    categories: ['dushi', 'xiandai'],
    rating: 6.8,
    year: 2020,
    episodes: 43,
    status: '已完结',
    actors: ['江疏影', '童瑶', '杨玏', '毛晓彤'],
    director: '张晓波',
    region: '中国大陆',
    language: '汉语普通话',
    updateInfo: '全43集',
    featured: false,
    views: 28700000,
  },
  {
    id: 'drama-11',
    title: '山河令',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20poster%2C%20two%20warriors%20in%20flowing%20robes%20with%20fans%20and%20swords%2C%20mountain%20and%20river%20landscape%2C%20elegant%20wuxia%20aesthetic%2C%20dramatic%20lighting&width=600&height=800&seq=drama-cover-11&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20jianghu%20landscape%2C%20misty%20rivers%20and%20mountains%2C%20martial%20arts%20atmosphere%2C%20traditional%20Chinese%20aesthetic%2C%20dramatic%20natural%20scenery%2C%20cinematic%20composition&width=1600&height=700&seq=drama-banner-11&orientation=landscape',
    description: '天窗首领周子舒为求自由之身，不惜以生命为代价退出组织。在流浪江湖的过程中，他遇见了神秘的温客行，两人因卷入江湖纷争而相识相知。',
    longDescription: '《山河令》改编自Priest小说《天涯客》，讲述了天窗首领周子舒为求自由，不惜以生命为代价退出组织，命不久矣之际遇上一心灭世的鬼谷谷主温客行，两人因卷入江湖纷争而相识相知，最终成为彼此救赎的故事。该剧以精美的服化道、扣人心弦的剧情和演员们出色的表演，在播出后迅速走红，成为年度爆款剧集之一。剧中的江湖世界构建和武打设计也获得了观众的高度认可。',
    category: 'wuxia',
    categories: ['wuxia', 'guzhuang'],
    rating: 8.3,
    year: 2021,
    episodes: 36,
    status: '已完结',
    actors: ['张哲瀚', '龚俊', '周也', '马闻远'],
    director: '成志超',
    region: '中国大陆',
    language: '汉语普通话',
    updateInfo: '全36集',
    featured: false,
    views: 19500000,
  },
  {
    id: 'drama-12',
    title: '流浪地球：超越',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%2C%20astronauts%20in%20futuristic%20space%20suits%2C%20Earth%20in%20background%20with%20engines%2C%20epic%20scale%2C%20dark%20space%20with%20stars%2C%20professional%20poster&width=600&height=800&seq=drama-cover-12&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Earth%20from%20space%20with%20massive%20engines%20propelling%20it%20through%20cosmos%2C%20frozen%20planet%20surface%2C%20epic%20sci-fi%20scale%2C%20dramatic%20space%20lighting%2C%20cinematic%20composition&width=1600&height=700&seq=drama-banner-12&orientation=landscape',
    description: '在不远的未来，太阳急速膨胀即将吞没地球，人类启动"流浪地球"计划，带着地球一起逃离太阳系，踏上长达2500年的星际流浪之旅。',
    longDescription: '《流浪地球：超越》延续了电影《流浪地球》的世界观，讲述了在"流浪地球"计划启动后，人类面临的一系列全新挑战。地球在穿越宇宙的旅途中遭遇未知的星际威胁，新一代的年轻人们挺身而出，在危机中成长，为人类的未来而战。该剧以宏大的宇宙视野和硬核的科幻设定，展现了人类在绝境中的勇气与智慧，特效力求达到国际一流水准，是中国科幻电视剧的又一力作。',
    category: 'kehuan',
    categories: ['kehuan', 'xiandai'],
    rating: 7.5,
    year: 2025,
    episodes: 36,
    status: '更新中',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    director: '郭帆',
    region: '中国大陆',
    language: '汉语普通话',
    updateInfo: '更新至24集',
    featured: true,
    views: 32100000,
  },
];

export function getDramasByCategory(categorySlug: string): Drama[] {
  if (categorySlug === 'all') return dramas;
  return dramas.filter((d) => d.categories.includes(categorySlug));
}

export function getDramaById(id: string): Drama | undefined {
  return dramas.find((d) => d.id === id);
}

export function getFeaturedDramas(): Drama[] {
  return dramas.filter((d) => d.featured);
}

export function getRelatedDramas(currentId: string, categories: string[]): Drama[] {
  return dramas.filter((d) => d.id !== currentId && d.categories.some((c) => categories.includes(c))).slice(0, 4);
}